<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">Consulta Pendências</v-card-title>
            <v-card-text class="app-card-content"></v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  metaInfo: {
    title: "Consulta Pendências - Central de Serviços"
  }
};
</script>

<style>
</style>